let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jd0MW")).then(() => parcelRequire('hy1lX'));